import { CodeHighlight } from "@mantine/code-highlight";

interface JsonFormatterProps {
    content: string;
}

/**
 * Component that formats and displays JSON content with syntax highlighting
 * If the content is not valid JSON, it displays it as plain text
 */
function JsonFormatter({ content }: JsonFormatterProps) {
    try {
        // Try to parse as JSON
        const parsed = JSON.parse(content);
        const formattedJson = JSON.stringify(parsed, null, 2);

        return (
            <div style={{ minWidth: 0 }}>
                <CodeHighlight language="json" code={formattedJson} copyLabel="Copy code" copiedLabel="Copied!" />
            </div>
        );
    } catch (_e) {
        // If not valid JSON, render as regular text
        return <div>{content}</div>;
    }
}

export default JsonFormatter;
